import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { HolidayInfo } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { usePermissionCheck } from 'src/hooks/permission-check.hook';
import { HOLIDAY_MANAGER_PAGES } from 'src/pages/settings/components/holiday-manager/holiday-manager.constants';
import { useHolidayNavigate } from 'src/pages/settings/components/holiday-manager/holiday-manager.hook';

const HolidayDetailsInfo = ({ data }: { data: any }) => {
  const { t } = useTranslation(['common', 'settings']);
  const { pageNavigate } = useHolidayNavigate();
  const { checkRule } = usePermissionCheck(PLATFORM_PERMISSIONS.holidayManagement);

  return (
    <HolidayInfo
      t={t}
      pageNavigate={() => pageNavigate(HOLIDAY_MANAGER_PAGES.edit, data._id)}
      data={data}
      canEdit={!checkRule(PERMISSION_ACTIONS.update, id => id === data.createdBy)}
    />
  );
};

export default HolidayDetailsInfo;
